// extracted by mini-css-extract-plugin
export default {"client":"Client_client__nidBX"};